import {z} from "zod/v4";

export const location = z.object({
    formattedAddress: z.string(),
    location: z.object({
        lat: z.number(),
        lng: z.number(),
    }),
    addressComponents: z.array(z.object({
        longText: z.string(),
        shortText: z.string(),
        types: z.array(z.string()),
    })),
    placeId: z.string(),
    description: z.string(),
})
